import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import TemplateManage from '@/views/marketing/marketingManage/templateManage/index.vue'


const __default__ = { name: 'DcCosOFbuTemplateManage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const permission = {
  add: 'ofbu_tpl_add_btn',
  del: 'ofbu_tpl_del_btn',
  edit: 'ofbu_tpl_edit_btn'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TemplateManage, {
    subdomain: "ofbu",
    permission: permission
  }))
}
}

})